import axios from "axios";
import { useState } from "react";
import { toast } from "react-toastify";

const useGetDoctorStaticById = () => {
  const [doctorStatic, setDoctorStatic] = useState(null);
  const [isDoctorStaticLoading, setIsDoctorStaticLoading] = useState(false);

  const getDoctorStaticById = async (docId) => {
    setIsDoctorStaticLoading(true);
    setDoctorStatic(null);
    try {
      const token = localStorage.getItem("authToken");
      
      const res = await axios.get(
        `/api/v1/phr-app/doctor-static-data/${docId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "ngrok-skip-browser-warning": "hgs",
          },
        }
      );
      setDoctorStatic(res.data || null);
      return res.data;
    } catch (error) {
      console.error(error, "error");
      const errorMessage = error.response?.data?.message;
      if (!error.response) {
        toast.error("Oops, something went wrong");
      } else {
        const messageContent = Array.isArray(errorMessage) ? (
          <ul className="ms-2 list-disc">
            {errorMessage.map((msg, index) => (
              <li key={index}>{msg}</li>
            ))}
          </ul>
        ) : (
          errorMessage || "An unknown error occurred"
        );
        toast.error(messageContent);
        if (error.response?.data?.statusCode === 401) {
          localStorage.removeItem("authToken");
          setTimeout(() => {
            window.location.href = "/";
          }, 1000);
        }
      }
      setDoctorStatic(null);
      return null;
    } finally {
      setIsDoctorStaticLoading(false);
    }
  };

  return {
    doctorStatic,
    isDoctorStaticLoading,
    getDoctorStaticById,
  };
};

export default useGetDoctorStaticById;

